var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckBadge = function SvgCheckBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#19AF00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6 8.5 7.5 10 10 6.5M14 8c0 .846-.42 1.593-1.062 2.045.134.775-.098 1.6-.696 2.198a2.5 2.5 0 0 1-2.197.695A2.5 2.5 0 0 1 8 14c-.845 0-1.593-.42-2.045-1.062a2.5 2.5 0 0 1-2.198-.695 2.5 2.5 0 0 1-.695-2.198A2.5 2.5 0 0 1 2 8c0-.845.42-1.593 1.062-2.045-.134-.774.097-1.6.695-2.198a2.5 2.5 0 0 1 2.198-.695A2.5 2.5 0 0 1 8 2c.845 0 1.593.42 2.045 1.062.775-.134 1.6.097 2.198.695s.83 1.424.695 2.198A2.5 2.5 0 0 1 14 8"
  })));
};
export { SvgCheckBadge as ReactComponent };
export default __webpack_public_path__ + "533b33161e50d853d08cf81ed4509974.svg";